var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isActive && _vm.isVisible)?_c('button',{staticClass:"btn rounded-circle back__to--top",attrs:{"type":"button","id":"btn-back-to-top"},on:{"click":_vm.backToTop}},[_c('i',{staticClass:"fas fa-arrow-up"})]):_vm._e()],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }